import { Component, OnInit } from '@angular/core';
import { EmailTemplate } from '../../../dto/templates/email-template';
import {HtmlTemplate, PushNotificationTemplate} from "../../../dto/templates/html-template";
import { OrderEmailTemplatesService } from '../../services/order-email-templates.service';
import { InvoiceEmailTemplatesService } from '../../services/invoice-email-templates.service';
import { InvoiceType } from '../../../dto/invoice-type';
import {EPushNotificationReminderType, ReminderType} from "../../../dto/reminder-type";
import {CustomerEmailTemplatesService} from '../../services/customer-email-templates.service';
import {PushNotificationTemplatesService} from "../../../services/crud/push-notification-templates.service";

@Component({
  selector: 'app-config',
  templateUrl: './configs.component.html',
  styleUrls: ['./configs.component.css']
})
export class ConfigsComponent implements OnInit {
  orderEmailTemplates: EmailTemplate[];
  customerEmailTemplates: EmailTemplate[];
  invoiceEmailTemplates: EmailTemplate[];
  invoiceType = InvoiceType;
  reminderType = ReminderType;
  ePushNotificationReminderType = EPushNotificationReminderType;
  pushNotificationTemplates: PushNotificationTemplate[];

  constructor(
    private orderEmailTemplateService: OrderEmailTemplatesService,
    private customerEmailTemplateService: CustomerEmailTemplatesService,
    private invoiceEmailTemplateService: InvoiceEmailTemplatesService,
    private pushNotificationTemplateService: PushNotificationTemplatesService,
  ) { }

  ngOnInit() {

    this.pushNotificationTemplateService.getMany().subscribe(result => {
      this.pushNotificationTemplates = result.data;
    });

    this.orderEmailTemplateService.getMany().subscribe(result => {
      this.orderEmailTemplates = result.data;
    });
    this.invoiceEmailTemplateService.getMany().subscribe(result => {
      this.invoiceEmailTemplates = result.data;
    });
    this.customerEmailTemplateService.getMany().subscribe(result => {
      this.customerEmailTemplates = result.data;
    });
  }

}
